import { render, staticRenderFns } from "./initial-town.vue?vue&type=template&id=4eb354ea&scoped=true&"
import script from "./initial-town.vue?vue&type=script&lang=js&"
export * from "./initial-town.vue?vue&type=script&lang=js&"
import style0 from "./initial-town.vue?vue&type=style&index=0&id=4eb354ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb354ea",
  null
  
)

export default component.exports